import { GENERAL_PROFILE } from "./general.js";
import { ONLINE_STORE_PROFILE } from "./online-store.js";
import { RETAIL_SHOP_PROFILE } from "./retail-shop.js";
import { RESTAURANT_PROFILE } from "./restaurant.js";
import { CLINIC_PROFILE } from "./clinic.js";
import { SALON_PROFILE } from "./salon.js";
import { CAR_WORKSHOP_PROFILE } from "./car-workshop.js";
import { SERVICES_PROFILE } from "./services.js";
import { TRAVEL_PROFILE } from "./travel.js";
import { REAL_ESTATE_PROFILE } from "./real-estate.js";
import { isBusinessTypeId, type BusinessTypeId } from "../business-types.js";
import type { VerticalProfile } from "./types.js";

export * from "./types.js";
export { defineProfile } from "./define.js";

/** One profile per business type (OWN-14). */
export const PROFILES: Readonly<Record<BusinessTypeId, VerticalProfile>> = {
  general: GENERAL_PROFILE,
  online_store: ONLINE_STORE_PROFILE,
  retail_shop: RETAIL_SHOP_PROFILE,
  restaurant: RESTAURANT_PROFILE,
  clinic: CLINIC_PROFILE,
  salon: SALON_PROFILE,
  car_workshop: CAR_WORKSHOP_PROFILE,
  services: SERVICES_PROFILE,
  travel: TRAVEL_PROFILE,
  real_estate: REAL_ESTATE_PROFILE,
};

/** The profile of a type; null, unknown or absent types get the `general` profile. */
export function profileFor(type: string | null | undefined): VerticalProfile {
  return isBusinessTypeId(type) ? PROFILES[type] : PROFILES.general;
}
